import React from 'react';
import { useNavigate } from 'react-router-dom';
import astronautCongratulate from '../../assets/poses/astronout-standing-congratulate.svg';
import logo from '../../assets/ecomlovers-logo-transparente.svg';
import './CompanyRegistrationForm.css';

const CompanyRegistrationSuccess = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    // Limpar o sessionStorage antes de navegar
    sessionStorage.removeItem('companyRegistrationComplete');
    navigate('/companies/panel');
  };

  return (
    <div className="company-registration-container">
      <img src={logo} alt="eComLovers Logo" className="company-logo success-logo" />
      <div className="company-registration-form success-modal">
        <div className="success-screen">
          <div className="success-icon">
            <img src={astronautCongratulate} alt="Astronauta celebrando" />
          </div>
          <h2>Cadastro Realizado!</h2>
          <p className="success-message">Parabéns! Seu cadastro foi realizado com sucesso na eComLovers.</p>
          <div className="login-section">
            <button
              onClick={handleLoginClick}
              className="enter-btn"
            >
              Entrar na plataforma
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyRegistrationSuccess;
